import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

// The gate on the admin shell: a valid (or refreshable) session passes; anything else lands on
// our own login page with the intended destination preserved. In-app navigation cannot loop the
// way the cross-domain hosted redirect could, so no cooldown machinery is needed here.
export const authGuard: CanActivateFn = async (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (await auth.ensureSession()) {
        // A Google sign-in that just completed lands on the ROOT, because the SPA origin is the only
        // redirect URI the app client trusts. Carry the visitor the rest of the way to wherever they
        // were actually headed when the guard first turned them away.
        const returnUrl = auth.takeReturnUrl();
        return returnUrl && returnUrl.startsWith('/') && returnUrl !== state.url
            ? router.createUrlTree([returnUrl])
            : true;
    }
    return router.createUrlTree(['/auth/login'], { queryParams: state.url && state.url !== '/' ? { returnUrl: state.url } : {} });
};
